import { t as translateDate } from './translate-date.js';
import { U as Url } from './url.min.js';
import './index2.js';

/**
 * **Reseze**
 *
 * @exports bs_256
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  const isLesSuites = thn.data.propertyId === 1031978;

  /**
   * @memberOf module:bs_256
   * @see {@link prestart}
   *
   * @param {object} ctx - The context object.
   */
  engine.boot = function boot() {
    thn.resezeApplyPromocode = ((data) => {
      if (thn.data.media.name === 'mobile') {
        const sendFormPost = function (params) {
          const form = document.createElement('form');
          form.setAttribute('method', 'post');
          form.setAttribute('action', '/servlet/WebresShowAvailable');

          Object.keys(params).forEach((key) => {
            const hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', key);
            hiddenField.setAttribute('value', params[key]);
            form.appendChild(hiddenField);
          });

          document.body.appendChild(form);
          form.submit();
        };

        const dateText = document.querySelector('#rw_room_booking_summary_arrivalDate .rwm_room_booking_summary_data')?.textContent?.trim() || '';
        const dateArray = translateDate(dateText, thn.data.language || 'en')?.split('/') || [];
        const nightsText = document.querySelector('#rw_room_booking_summary_nightsStay .rwm_room_booking_summary_data')?.textContent;
        const roomsText = document.querySelector('#rw_room_booking_summary_numberRooms .rwm_room_booking_summary_data')?.textContent;
        const adultsText = document.querySelector('#rw_room_booking_summary_adults .rwm_room_booking_summary_data')?.textContent;
        const childrenText = document.querySelector('#rw_room_booking_summary_children .rwm_room_booking_summary_data')?.textContent;
        const rwidEl = document.querySelector('input[name="rwid"]')?.value;
        const params = {
          rwid: rwidEl,
          arrivalMonth: thn.parseNumber(dateArray[1]) - 1,
          arrivalDay: thn.parseNumber(dateArray[2]),
          arrivalYear: thn.parseNumber(dateArray[0]),
          nightsStay: thn.parseNumber(nightsText),
          buildingCodeRoomType: 'any|any',
          numberRooms: thn.parseNumber(roomsText),
          adults: thn.parseNumber(adultsText),
          children: thn.parseNumber(childrenText) || 0,
          age3: 0,
          age4: 0,
          rateCode: data.code,
          groupId: '',
          iataNumber: '',
          ownerReservation: false,
          check: 'Check Now',
        };

        sendFormPost(params);
      } else {
        const promoInput = document.querySelector('#rateCode');
        const promoSubmit = document.querySelector('form .rw_av_pr_submit input');
        if (promoInput && promoSubmit) {
          promoInput.value = data.code;
          promoSubmit.click();
        }
      }
    });
  };

  /**
     * @memberOf module:bs_256
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    const { query } = new Url(window.location.href);

    // Mobile version
    if (document.querySelector('.rwm_showAvailable_block')) {
      const dateBeginText = (document.querySelector('.rwm_reservations_arrival')
      || document.querySelector('#rw_room_booking_summary_arrivalDate .rwm_room_booking_summary_data')
      || document.querySelector('#rw-hotel-datepickerDisplay')?.textContent?.split('-')?.[0]
      || {}).textContent;
      const dateEndText = (document.querySelector('.rwm_reservations_departure')
      || document.querySelector('#rw_room_booking_summary_departureDate .rwm_room_booking_summary_data')
      || document.querySelector('#rw-hotel-datepickerDisplay')?.textContent?.split('-')?.[1]?.split('(')?.[0]
      || {}).textContent;
      if (dateBeginText && dateEndText) {
        widgetData.dateBegin = translateDate(dateBeginText, thn.data.language);
        widgetData.dateEnd = translateDate(dateEndText, thn.data.language);
      }

      const guests = ((document.querySelector('.rwm_reservationSummary4') || {}).textContent || '').split(/\s/).filter((el) => parseInt(el, 10));

      if (guests.length) {
        widgetData.adults = parseInt(guests[0], 10) || 2;
        widgetData.children = parseInt(guests[1], 10) || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
      } else if (document.querySelector('#rw_room_booking_summary_adults .rwm_room_booking_summary_data')) {
        widgetData.adults = thn.parseNumber((document.querySelector('#rw_room_booking_summary_adults .rwm_room_booking_summary_data') || {}).textContent) || 2;
        widgetData.children = thn.parseNumber((document.querySelector('#rw_room_booking_summary_children .rwm_room_booking_summary_data') || {}).textContent) || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
      }

      // Desktop version
    } else {
      // Dates
      const daySelector = document.getElementById('arrivalDay'),
        monthSelector = document.getElementById('arrivalMonth'),
        yearSelector = document.getElementById('arrivalYear'),
        stayLengthSelector = document.getElementById('nightsStay');

      let dayText,
        monthText,
        year,
        stayLength;

      if (daySelector) {
        dayText = ((daySelector.options || {})[daySelector.selectedIndex] || {}).value;
      }

      if (monthSelector) {
        monthText = ((monthSelector.options || {})[monthSelector.selectedIndex] || {}).value;
      }

      if (yearSelector) {
        year = ((yearSelector.options || {})[yearSelector.selectedIndex] || {}).value;
      }

      if (stayLengthSelector) {
        stayLength = ((stayLengthSelector.options || {})[stayLengthSelector.selectedIndex] || {}).value;
      }

      if (year && monthText && dayText) {
        const month = `0${parseInt(monthText, 10) + 1}`.slice(-2);
        const day = `0${parseInt(dayText, 10)}`.slice(-2);

        widgetData.dateBegin = `${year}/${month}/${day}`;

        widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, stayLength));
      }
      if (!widgetData.dateBegin || !widgetData.dateEnd) {
        const dateBegin = document.querySelector('#rw-hotel-datepickerDisplay')?.textContent?.split('-')?.[0];
        const dateEnd = document.querySelector('#rw-hotel-datepickerDisplay')?.textContent?.split('-')?.[1]?.split('(')?.[0];
        if (dateBegin && dateEnd) {
          widgetData.dateBegin = translateDate(dateBegin, thn.data.language);
          widgetData.dateEnd = translateDate(dateEnd, thn.data.language);
        }
      }
      // Guests, Adults & Children
      const adultsSelector = document.getElementById('adults') || document.getElementById('rw_adults-total');
      if (adultsSelector) {
        const adults = ((adultsSelector.options || {})[adultsSelector.selectedIndex] || {}).value || adultsSelector.value;
        if (adults) {
          widgetData.adults = parseInt(adults, 10) || 2;
        }
      }
      const childrenSelector = document.getElementById('children') || document.getElementById('rw_children-total');
      if (childrenSelector) {
        const children = ((childrenSelector.options || {})[childrenSelector.selectedIndex] || {}).value || childrenSelector.value;
        if (children) {
          widgetData.children = parseInt(children, 10) || 0;
        }
      }

      if (widgetData.adults) {
        widgetData.guests = widgetData.adults + widgetData.children;
      }
    }

    // Fallback dates
    if ((!widgetData.dateBegin || !widgetData.dateEnd)) {
      if (thn.empty(query)) {
        const dateBegin = document.querySelector('#rw_room_booking_summary_arrivalDate .rw_room_booking_summary_data')?.textContent;
        const dateEnd = document.querySelector('#rw_room_booking_summary_departureDate .rw_room_booking_summary_data')?.textContent;
        if (dateBegin && dateEnd) {
          widgetData.dateBegin = translateDate(dateBegin, thn.data.language);
          widgetData.dateEnd = translateDate(dateEnd, thn.data.language);
        } else {
          widgetData.dateBegin = thn.objectGet(thn.objectGet(window.dataLayer, 'items', { first: false }), 'item_category2')?.replace(/-/g, '/');
          widgetData.dateEnd = thn.objectGet(thn.objectGet(window.dataLayer, 'items', { first: false }), 'item_category3')?.replace(/-/g, '/');
        }
      } else if (query.arrivalDate && query.nightsStay) {
        widgetData.dateBegin = query.arrivalDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3');
        widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, thn.parseNumber(query.nightsStay)));
      }
    }

    // Fallback guests
    // PID 1042713
    const fallbackGuestsText = document.querySelector('#rw_pageid_showAvailable .standard ')?.innerText?.split(/,/)?.pop()?.split('and');
    const fallbackAdults = !thn.empty(fallbackGuestsText) && thn.parseNumber(fallbackGuestsText?.[0]);
    const fallbackChildren = !thn.empty(fallbackGuestsText) && thn.parseNumber(fallbackGuestsText?.[1]);
    if (!widgetData.guests) {
      widgetData.adults = parseInt(query.adults, 10) || fallbackAdults || thn.parseNumber(thn.objectGet(thn.objectGet(window.dataLayer, 'items', { first: false }), 'item_category4')) || 2;
      widgetData.children = parseInt(query.children, 10) || fallbackChildren || 0;
      widgetData.guests = widgetData.adults + widgetData.children;
    }

    widgetData.rooms = 1;

    // Prices & Currency || No Rooms
    const prices = [...document.querySelectorAll('.rw_av_amount, .rwm_av_amount')]?.map((el) => thn.parseNumber(el.textContent));
    const price = !thn.empty(prices) && Math.min(...prices);

    const currency = isLesSuites ? 'CAD' : 'USD';

    if (!price) {
      widgetData.noRooms = true;
    } else {
      widgetData.currency = currency;
      widgetData.price = price;
      widgetData.set = true;
    }

    widgetData.priceSpecial = ((((document.querySelector('.rw_av2_rate_data') || {}).textContent || '').match(/Spa Package/)) ? 1 : 0);

    return widgetData;
  };

  /**
     * @memberOf module:bs_256
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    widgetData.bookingId = thn.dataLayerHelper.get('transactionId') || document.querySelector('#rw_confirmationNumberField')?.textContent?.trim();

    if (!widgetData.bookingId) {
      thn.logger.debug('************** Booking ID does not exist *****************');
      return widgetData;
    }

    const startDate = (window && window.res_arrivalDate) || document.querySelector('#rw_roomBookingSummaryArrivalDateField')?.textContent?.trim();
    const endDate = (window && window.res_departureDate) || document.querySelector('#rw_roomBookingSummaryDepartureDateField')?.textContent?.trim();

    if (startDate && endDate) {
      widgetData.dateBegin = translateDate(startDate, thn.data.language);
      widgetData.dateEnd = translateDate(endDate, thn.data.language);
    }

    widgetData.price = parseFloat(((document.querySelector('#rw_room_booking_summary_grandTotal>.rw_room_booking_summary_amount, #rw_roomBookingSummaryGrandTotalField') || {}).textContent || '').slice(1));
    widgetData.currency = isLesSuites ? 'CAD' : 'USD';

    return widgetData;
  };

  /**
     * @memberOf module:bs_256
     * @this thn.widgets.price
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
  engine.getPromocode = function getPromocode(ctx) {
    const inputPromoDesktop = document.querySelector('#rateCode')?.value;
    ctx.promocode = inputPromoDesktop || '';
    return ctx.promocode;
  };

  return engine;

}

export { factory };
